import pick from 'lodash/pick';
import {
  createStripeAccount,
  updateStripeAccount,
  fetchStripeAccount,
} from '../../ducks/stripeConnectAccount.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { walletCurrentYearEarning } from '../../util/api';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/StripePayoutPage/SET_INITIAL_VALUES';
export const SAVE_PAYOUT_DETAILS_REQUEST = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_REQUEST';
export const SAVE_PAYOUT_DETAILS_SUCCESS = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_SUCCESS';
export const SAVE_PAYOUT_DETAILS_ERROR = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_ERROR';

const GET_EARNING_REQUEST = 'app/StripePayoutPage/GET_EARNING_REQUEST';
const GET_EARNING_SUCCESS = 'app/StripePayoutPage/GET_EARNING_SUCCESS';
const GET_EARNING_ERROR = 'app/StripePayoutPage/GET_EARNING_ERROR';

// ================ Reducer ================ //

const initialState = {
  payoutDetailsSaveInProgress: false,
  payoutDetailsSaved: false,
  fromReturnURL: false,
  earning: [],
  getEarningError: null,
  getEarningInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SAVE_PAYOUT_DETAILS_REQUEST:
      return { ...state, payoutDetailsSaveInProgress: true };
    case SAVE_PAYOUT_DETAILS_ERROR:
      return { ...state, payoutDetailsSaveInProgress: false };
    case SAVE_PAYOUT_DETAILS_SUCCESS:
      return { ...state, payoutDetailsSaveInProgress: false, payoutDetailsSaved: true };
    case GET_EARNING_REQUEST:
      return { ...state, getEarningError: null, getEarningInProgress: true };
    case GET_EARNING_SUCCESS:
      return { ...state, earning: payload, getEarningInProgress: false };
    case GET_EARNING_ERROR:
      return { ...state, getEarningError: payload, getEarningInProgress: false };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const savePayoutDetailsRequest = () => ({
  type: SAVE_PAYOUT_DETAILS_REQUEST,
});
export const savePayoutDetailsError = () => ({
  type: SAVE_PAYOUT_DETAILS_ERROR,
});
export const savePayoutDetailsSuccess = () => ({
  type: SAVE_PAYOUT_DETAILS_SUCCESS,
});

// ================ Thunks ================ //

export const savePayoutDetails = (values, isUpdateCall) => dispatch => {
  const upsertThunk = isUpdateCall ? updateStripeAccount : createStripeAccount;
  dispatch(savePayoutDetailsRequest());

  return dispatch(upsertThunk(values, { expand: true }))
    .then(response => {
      dispatch(savePayoutDetailsSuccess());
      return response;
    })
    .catch(() => dispatch(savePayoutDetailsError()));
};

const getEarningRequest = () => ({
  type: GET_EARNING_REQUEST,
});
const getEarningSuccess = earning => ({
  type: GET_EARNING_SUCCESS,
  payload: earning,
});

const getEarningError = error => ({
  type: GET_EARNING_ERROR,
  payload: error,
  error: true,
});

export const getEarning = () => async dispatch => {
  try {
    dispatch(getEarningRequest());
    const response = await walletCurrentYearEarning();
    const { earning } = response.data;
    dispatch(getEarningSuccess(earning));
  } catch (e) {
    dispatch(getEarningError(storableError(e)));
  }
};

export const loadData = () => (dispatch, getState) => {
  dispatch(setInitialValues());

  return dispatch(fetchCurrentUser()).then(response => {
    const { currentUser } = getState().user;
    if (currentUser && currentUser.stripeAccount) {
      dispatch(fetchStripeAccount());
      dispatch(getEarning());
    }
    return response;
  });
};
